import React from 'react';
import BlogList from '../components/BlogList';

const Blog = () => {
  return (
    <div className="min-h-screen bg-gray-100 pt-20">
      <BlogList />
    </div>
  );
};

export default Blog;
